export default "__VITE_ASSET__DROTD_dk__"